var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/blur"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blur"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.45 12.7439L26.55 10.7272C27.05 10.4772 27.1833 9.82725 26.8 9.42725C25.3167 7.79391 23.8167 6.42725 22.6167 5.39391C22.0667 4.92725 21.25 5.31058 21.25 6.02725V11.9939C21.25 12.6106 21.9 13.0106 22.45 12.7439Z",
    fill: "#29B719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.25 33.2951V36.0451C21.25 36.5451 21.7 36.9618 22.2 36.8784C26.75 36.1284 30.55 33.0784 32.35 28.9784C32.6667 28.2784 31.9 27.5784 31.2 27.9118L21.7167 32.5618C21.4333 32.6951 21.25 32.9784 21.25 33.2951Z",
    fill: "#29B719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.7501 5.99392C18.7501 5.27725 17.9335 4.89392 17.3835 5.34392C13.4501 8.64392 6.46679 15.5939 6.50012 23.5606C6.50012 30.2606 11.4001 35.8106 17.8001 36.8772C18.3001 36.9606 18.7501 36.5439 18.7501 36.0439V5.99392Z",
    fill: "#29B719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.401 21.1783L31.2177 17.4783C31.6677 17.2783 31.8844 16.7616 31.6677 16.3283C31.051 15.1116 30.3344 13.9283 29.551 12.8283C29.3177 12.4949 28.8844 12.3949 28.5177 12.5616L21.701 15.8783C21.4177 16.0116 21.2344 16.3116 21.2344 16.6283V20.4116C21.251 20.9949 21.851 21.4116 22.401 21.1783Z",
    fill: "#29B719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.05 24.245C33.3167 24.1117 33.4833 23.8617 33.4833 23.5784C33.4833 22.5117 33.35 21.4617 33.1167 20.4284C33 19.9284 32.45 19.6617 31.9833 19.8617L21.75 24.2284C21.45 24.3617 21.25 24.6617 21.25 24.995V28.6617C21.25 29.2784 21.9 29.6784 22.45 29.4117L32.2833 24.6284L33.05 24.245Z",
    fill: "#29B719"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/blur.9fa26255f8793719c1f9a90307bbe698.svg";
export { ForwardRef as ReactComponent };